import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ContinueToNextViewButton } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ContinueToNextViewButton";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { ErrorNotValidEmail } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ErrorMessage";
import { LoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoginError";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useSignInEventTracker } from "@faire/retailer-visitor-shared/components/AppSignIn/useSignInEventTracker";
import { SocialSignOnButtons } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/index";
import { useFetchHCaptchaToken } from "@faire/retailer-visitor-shared/hooks/hCaptcha/useFetchHCaptchaToken";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { getPayloadForConfirmPassword, showSSOButtonsOnSignIn } from "@faire/retailer-visitor-shared/lib/ssoUtils";
import { isValidEmail } from "@faire/retailer-visitor-shared/lib/validation";
import { getSettingEnableHCaptchaForLoginData } from "@faire/retailer-visitor-shared/settings/getSettingEnableHCaptchaForLoginData";
import { useSettingMfaTimingXP } from "@faire/retailer-visitor-shared/settings/useSettingSignInImprovements";
import { useSSOErrorStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOErrorStore";
import { useSSOPasswordStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOPasswordStore";
import { useSSOProviderOptionsStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOProviderOptionsStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { emitDatadogError } from "@faire/web--source/common/datadog/rum";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Input } from "@faire/web--source/slate/Input";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import userLoginData from "@faire/web-api--source/api/user/login-data/post";
import login from "@faire/web-api--source/api/v2/users/login/post";
import { trackRetailerPortalLoginModalEnterEmail } from "@faire/web-api--source/events/retailerPortal/actionUnknown/loginModalEnterEmail";
import { trackSigninTriggersMfaSubmit } from "@faire/web-api--source/events/signin/submit/triggersMfa";
import { ILoginDataRequest } from "@faire/web-api--source/indigofair/data/ILoginDataRequest";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled, { keyframes } from "styled-components";
export var EnterEmailView = function(param) {
    var onComplete = param.onComplete, onLogin = param.onLogin, defaultEmail = param.defaultEmail, signInTitle = param.signInTitle, hideApple = param.hideApple, isResetPasswordSuccess = param.isResetPasswordSuccess;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(defaultEmail), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isLoading = _useState2[0], setIsLoading = _useState2[1];
    var fetchHCaptchaToken = useFetchHCaptchaToken(getSettingEnableHCaptchaForLoginData()).fetchHCaptchaToken;
    var trackFieldValue = useSignInEventTracker("ENTER_EMAIL").trackFieldValue;
    var settingMfaTimingXP = useSettingMfaTimingXP();
    var queryParams = parseQueryParams(useLocation().search);
    var oktaSignInFailed = queryParams.get("error") === "USER_NOT_ASSIGNED";
    useEffect(function() {
        if (oktaSignInFailed) {
            setError(new LoginError(strictLocalize({
                id: "SqkBAT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Failed to sign in with Okta, please use email and password"
                    }
                ]
            })));
        }
    }, [
        oktaSignInFailed,
        strictLocalize
    ]);
    var userClickedSSOButton = useSSOStore().userClickedSSOButton;
    var setUserHasPassword = useSSOPasswordStore().setUserHasPassword;
    var setProviders = useSSOProviderOptionsStore().setProviders;
    var _useSSOErrorStore = useSSOErrorStore(), errorMessage = _useSSOErrorStore.errorMessage, resetErrorMessage = _useSSOErrorStore.resetErrorMessage;
    var onContinue = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var result, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(email !== undefined)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            handleEmailSubmit(email, strictLocalize, fetchHCaptchaToken, setProviders, setUserHasPassword, settingMfaTimingXP, setIsLoading)
                        ];
                    case 2:
                        result = _state.sent();
                        setError(undefined);
                        onComplete(result);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        emitDatadogError(error);
                        setError(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSignIn = function(user) {
        onLogin(user);
        onComplete({
            nextView: View.LOADING,
            user: user
        });
    };
    //TODO: ADD NEW MFA UI FOR SSO
    var onSelectMFA = function(mfaOptions) {
        return onComplete({
            nextView: View.SELECT_MFA_OPTION,
            email: email,
            mfaOptions: mfaOptions
        });
    };
    var onMFA = function(mfaDescription, mfaTitle) {
        return onComplete({
            nextView: View.ENTER_MFA,
            mfaDescription: mfaDescription,
            mfaTitle: mfaTitle
        });
    };
    var onConfirmPassword = function(signUpSuggestions) {
        return onComplete(_object_spread_props(_object_spread({}, getPayloadForConfirmPassword(signUpSuggestions)), {
            nextView: View.CONFIRM_PASSWORD
        }));
    };
    var handleInputChange = function(event) {
        if (errorMessage) {
            resetErrorMessage();
        }
        if (error) {
            setError(undefined);
        }
        setEmail(event.currentTarget.value);
    };
    var emailInputRef = React.useCallback(function(element) {
        if (element) {
            // Handle case where user has entered text during SSR by updating state on hydration.
            setEmail(element.value);
        }
    }, [
        setEmail
    ]);
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            isResetPasswordSuccess ? /*#__PURE__*/ _jsx(AnimatedTextWrapper, {
                children: /*#__PURE__*/ _jsx(StyledText, {
                    children: /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.inverse,
                        children: strictLocalize({
                            id: "Z+q9tl",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Your password has been changed."
                                }
                            ]
                        })
                    })
                })
            }) : null,
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                children: signInTitle
            }),
            userClickedSSOButton && errorMessage ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: 4
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.critical,
                        role: "alert",
                        align: {
                            mobileAndAbove: "center",
                            desktopAndAbove: "start"
                        },
                        children: errorMessage
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Input, {
                autoFocus: true,
                autoComplete: "email",
                label: strictLocalize({
                    id: "jXgcmC",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Email address"
                        }
                    ]
                }),
                "aria-label": strictLocalize({
                    id: "qY/s5t",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Email"
                        }
                    ]
                }),
                name: "email",
                value: email,
                onChange: handleInputChange,
                onBlur: function(e) {
                    trackFieldValue("emailaddress", e.currentTarget.value);
                },
                onKeyDown: handleKeyDown(onContinue),
                "data-test-id": "email",
                ref: emailInputRef
            }),
            error ? /*#__PURE__*/ _jsxs("div", {
                style: {
                    marginTop: "-4px"
                },
                children: [
                    /*#__PURE__*/ _jsx(ErrorNotValidEmail, {
                        error: error,
                        email: email
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: 12
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Spacer, {
                size: "3x"
            }),
            /*#__PURE__*/ _jsx(ContinueToNextViewButton, {
                onClick: onContinue,
                disabled: isSSR,
                isLoading: isLoading
            }),
            showSSOButtonsOnSignIn() ? /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(SocialSignOnButtons, {
                    onSignIn: onSignIn,
                    onSelectMFA: onSelectMFA,
                    onMFA: onMFA,
                    onConfirmPassword: onConfirmPassword,
                    hideApple: hideApple,
                    sourceId: "signin_modal_email_view",
                    isOnSignIn: true
                })
            }) : null
        ]
    });
};
var handleEmailSubmit = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(email_address, strictLocalize, fetchHCaptchaToken, setSSOProviders, setUserHasPassword, isMfaTimingXP, setIsLoading) {
        var validEmail, _ref, available_social_providers, missing_password, partial_alias, user_token, mfa_title, mfa_description, mfa_options, resultWithMFA, nextView, _available_social_providers_length, userToken, obfuscatedEmail, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email_address) {
                        throw new LoginError(strictLocalize({
                            id: "TeRKOF",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Please enter your email to continue."
                                }
                            ]
                        }));
                    }
                    validEmail = isValidEmail(email_address);
                    if (!validEmail) {
                        trackRetailerPortalLoginModalEnterEmail("NOT_EMAIL");
                        throw new LoginError(strictLocalize({
                            id: "oA2NHq",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Enter a valid email to continue."
                                }
                            ]
                        }));
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        6,
                        7
                    ]);
                    setIsLoading(true);
                    return [
                        4,
                        fetchHCaptchaToken(true).then(function() {
                            return userLoginData(ILoginDataRequest.build({
                                email_address: email_address,
                                enable_mfa_method_selection: true,
                                trigger_m_f_a: true
                            }));
                        })
                    ];
                case 2:
                    _ref = _state.sent(), available_social_providers = _ref.available_social_providers, missing_password = _ref.missing_password, partial_alias = _ref.partial_alias, user_token = _ref.user_token, mfa_title = _ref.mfa_title, mfa_description = _ref.mfa_description, mfa_options = _ref.mfa_options;
                    resultWithMFA = handleMFAOnEmailSubmit(mfa_title, mfa_description, mfa_options, email_address, user_token, isMfaTimingXP);
                    if (resultWithMFA) {
                        trackSigninTriggersMfaSubmit("EMAIL");
                        return [
                            2,
                            resultWithMFA
                        ];
                    }
                    nextView = View.ENTER_PASSWORD;
                    if (((_available_social_providers_length = available_social_providers === null || available_social_providers === void 0 ? void 0 : available_social_providers.length) !== null && _available_social_providers_length !== void 0 ? _available_social_providers_length : 0) > 0 && showSSOButtonsOnSignIn()) {
                        if (available_social_providers.includes(SocialSignOnProvider.OKTA)) {
                            trackRetailerPortalLoginModalEnterEmail("ADMIN");
                            nextView = View.SSO;
                        } else if (missing_password) {
                            trackRetailerPortalLoginModalEnterEmail("SSO");
                            nextView = View.SSO;
                        } else {
                            nextView = View.ENTER_PASSWORD;
                        }
                        setSSOProviders(available_social_providers.map(function(provider) {
                            return SocialSignOnProvider[provider];
                        }));
                        setUserHasPassword(!missing_password);
                    } else if (missing_password) {
                        trackRetailerPortalLoginModalEnterEmail("CODE");
                        nextView = View.ENTER_CODE;
                    }
                    userToken = user_token;
                    obfuscatedEmail = partial_alias;
                    if (!(nextView === View.ENTER_CODE)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        login(ILoginRequest.build({
                            email_address: email_address
                        }))
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        {
                            nextView: nextView,
                            userToken: userToken,
                            obfuscatedEmail: obfuscatedEmail,
                            email: email_address
                        }
                    ];
                case 4:
                    return [
                        2,
                        {
                            nextView: nextView,
                            userToken: userToken,
                            obfuscatedEmail: obfuscatedEmail,
                            email: email_address
                        }
                    ];
                case 5:
                    e = _state.sent();
                    throw convertErrorToLoginError(e, strictLocalize);
                case 6:
                    setIsLoading(false);
                    return [
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleEmailSubmit(email_address, strictLocalize, fetchHCaptchaToken, setSSOProviders, setUserHasPassword, isMfaTimingXP, setIsLoading) {
        return _ref.apply(this, arguments);
    };
}();
var handleMFAOnEmailSubmit = function(mfaTitle, mfaDescription, mfaOptions, emailAddress, userToken, isMFAxp) {
    if (!mfaTitle || !mfaDescription || !userToken || !isMFAxp) {
        return undefined;
    }
    if (mfaOptions.length > 1) {
        return {
            nextView: View.SELECT_MFA_OPTION,
            mfaTitle: mfaTitle,
            mfaDescription: mfaDescription,
            mfaOptions: mfaOptions,
            email: emailAddress,
            isMFAFromEmail: true
        };
    }
    return {
        nextView: View.ENTER_MFA,
        mfaTitle: mfaTitle,
        mfaDescription: mfaDescription,
        userToken: userToken,
        email: emailAddress,
        isMFAFromEmail: true
    };
};
var fadeInOut = keyframes([
    "0%{opacity:0;transform:translate(0px,-10px);}20%,90%{opacity:1;transform:translate(0px,-10px);}100%{opacity:0;transform:translate(0px,-20px);}"
]);
var AnimatedTextWrapper = styled.div.withConfig({
    componentId: "sc-db7cca9d-0"
})([
    "opacity:1;width:100%;transform:translate(0px,-10px);animation:",
    " 2200ms linear forwards;"
], fadeInOut);
var StyledText = styled.div.withConfig({
    componentId: "sc-db7cca9d-1"
})([
    "background-color:",
    ";padding:16px;border-radius:8px;max-width:315px;margin:0 auto;text-align:center;"
], Core.text.default);
